import React from "react";

import "./product-validation.css";

export interface ClickableWarning {
	message: string;
	onClick?: () => void;
}
export const ProductValidation = ({ warnings }: { warnings: readonly ClickableWarning[] }) => (
	<ul>
		{warnings.map(({ message, onClick }) => (
			// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
			<li
				key={message}
				className={onClick ? "product-validation--clickable" : ""}
				onClick={() => {
					if (onClick) onClick();
				}}
				dangerouslySetInnerHTML={{ __html: message }}
			/>
		))}
	</ul>
);
ProductValidation.displayName = "ProductValidation";
